module.exports = __webpack_public_path__ + "img/threat-analytics-processes.05c97164.png";